<div class="flex min-w-0 flex-auto flex-col p-6 sm:p-10">
    <div class="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
            <div class="text-sm font-semibold uppercase tracking-widest text-primary">Break Record</div>
            <h1 class="mt-1 text-4xl font-extrabold tracking-tight">Tableau de bord</h1>
            <p class="mt-2 text-secondary">La plateforme en un coup d’œil.</p>
        </div>
        <button mat-stroked-button type="button" (click)="load()" [disabled]="isLoading">
            <mat-icon>refresh</mat-icon>
            <span class="ml-2">Actualiser</span>
        </button>
    </div>

    <div *ngIf="isLoading" class="mt-8 flex items-center justify-center py-20">
        <mat-spinner diameter="42"></mat-spinner>
    </div>

    <div *ngIf="error && !isLoading" class="mt-8 rounded-lg bg-red-50 p-5 text-red-800">
        {{ error }}
    </div>

    <ng-container *ngIf="stats && !isLoading">
        <div class="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
            <div class="rounded-lg border bg-card p-5 shadow-sm">
                <div class="flex items-center justify-between text-secondary"><span>Joueurs</span><mat-icon class="text-primary">groups</mat-icon></div>
                <div class="mt-3 text-3xl font-bold">{{ stats.players_count | number }}</div>
            </div>
            <div class="rounded-lg border bg-card p-5 shadow-sm">
                <div class="flex items-center justify-between text-secondary"><span>Compétitions</span><mat-icon class="text-primary">emoji_events</mat-icon></div>
                <div class="mt-3 text-3xl font-bold">{{ stats.competitions_count | number }}</div>
            </div>
            <div class="rounded-lg border bg-card p-5 shadow-sm">
                <div class="flex items-center justify-between text-secondary"><span>Domaines</span><mat-icon class="text-primary">lightbulb</mat-icon></div>
                <div class="mt-3 text-3xl font-bold">{{ stats.domains_count | number }}</div>
            </div>
            <div class="rounded-lg border bg-card p-5 shadow-sm">
                <div class="flex items-center justify-between text-secondary"><span>Édition en cours</span><mat-icon class="text-primary">calendar_today</mat-icon></div>
                <div class="mt-3 text-3xl font-bold">{{ stats.current_edition_year }}</div>
            </div>
        </div>

        <div class="mt-8 grid grid-cols-1 gap-6 xl:grid-cols-3">
            <section class="rounded-lg border bg-card shadow-sm xl:col-span-2">
                <div class="flex items-center justify-between border-b px-5 py-4">
                    <div><h2 class="text-xl font-semibold">Compétitions</h2><p class="text-secondary">Les prochaines activités de la plateforme</p></div>
                    <a mat-button color="primary" [routerLink]="'/apps/competitions'">Voir tout</a>
                </div>
                <div *ngIf="competitions.length === 0" class="p-8 text-center text-secondary">Aucune compétition publiée.</div>
                <div *ngFor="let competition of competitions" class="flex flex-col gap-3 border-b px-5 py-4 last:border-b-0 sm:flex-row sm:items-center sm:justify-between">
                    <div class="min-w-0"><div class="truncate font-semibold">{{ competition.name }}</div><div class="text-sm text-secondary">{{ competition.code }} · {{ competition.d_day | date:'medium' }}</div></div>
                    <div class="flex items-center gap-4 text-sm"><span class="rounded-full px-3 py-1 font-medium" [ngClass]="stateClass(competition.state)">{{ stateLabel(competition.state) }}</span><span class="text-secondary">{{ competition.registrations_count || 0 }} inscrits</span></div>
                </div>
            </section>

            <section class="rounded-lg border bg-card shadow-sm">
                <div class="flex items-center justify-between border-b px-5 py-4"><div><h2 class="text-xl font-semibold">Publicités actives</h2><p class="text-secondary">Campagnes actuellement diffusées</p></div><a mat-button color="primary" [routerLink]="'/apps/partner-ads'">Gérer</a></div>
                <div *ngIf="ads.length === 0" class="p-8 text-center text-secondary">Aucune campagne active.</div>
                <div *ngFor="let ad of ads" class="flex items-center justify-between border-b px-5 py-4 last:border-b-0"><div><div class="font-semibold">{{ ad.partner?.name || 'Partenaire' }}</div><div class="text-sm text-secondary">{{ ad.media_type }} · {{ ad.position }}</div></div><mat-icon class="text-primary">campaign</mat-icon></div>
            </section>
        </div>
    </ng-container>
</div>
